import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'eui-card-footer-action-buttons',
    templateUrl: './eui-card-footer-action-buttons.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EuiCardFooterActionButtonsComponent {

    @HostBinding('class') string = 'eui-card-footer-actions__buttons';

    constructor() {
    }
}
